export default "__VITE_ASSET__JJOrNG3N__"